<template>
    <v-container fluid grid-list-md align-start>
        <v-card v-if="loaded && event && event.eventSchedules && event.eventSchedules.length > 0">
            <div class="headline pa-3">
                {{ event.name }}

                <v-btn
                    v-if="activeSchedule && activeSchedule.eventScheduleEntries && activeSchedule.eventScheduleEntries.length > 0"
                    @click="download"
                    class="right"
                    outline
                >
                    <v-icon>save_alt</v-icon>&nbsp;&nbsp;Download CSV
                </v-btn>
            </div>

            <v-card flat v-for="schedule in event.eventSchedules" :key="schedule.id">
                <table class="v-datatable v-table theme--light">
                    <thead>
                        <tr>
                            <th class="column text-xs-left"></th>
                            <th class="column text-xs-left">NR</th>
                            <th class="column text-xs-left">Tag</th>
                            <th class="column text-xs-left">Uhrzeit</th>
                            <th class="column text-xs-left">Programmpunkt</th>
                            <th class="column text-xs-left">Altersklasse</th>
                            <th class="column text-xs-left">Style</th>
                            <th class="column text-xs-left">Runde</th>
                            <th class="column text-xs-left">Starter</th>
                            <th class="column text-xs-left">Dauer</th>
                            <th class="column text-xs-left">Dauer pro Starter/Runde</th>
                            <th class="column text-xs-center">Autom.</th>
                            <th class="column"></th>
                        </tr>
                    </thead>
                    <draggable v-model="schedule.eventScheduleEntries" tag="tbody" @change="move" handle=".handle">
                        <tr v-show="entry.duration > 0" v-for="(entry, index) in schedule.eventScheduleEntries" :key="entry.id">
                            <td scope="row" class="handle">
                                <v-btn small icon :disabled="loading">
                                    <v-icon>drag_handle</v-icon>
                                </v-btn>
                            </td>
                            <td>{{ entry.competition_no }}</td>
                            <td>{{ entry.day }}</td>
                            <td>{{ entry.time }}</td>
                            <td>{{ entry.title }}</td>
                            <td>{{ entry.ageGroup ? entry.ageGroup.name : '' }}</td>
                            <td>{{ entry.starterStyle ? entry.starterStyle.name : '' }}</td>
                            <td>{{ entry.round }}</td>
                            <td>{{ entry.starter_count }}</td>
                            <td>{{ entry.duration }}</td>
                            <td>{{ entry.duration_per_starter }}</td>
                            <td class="text-xs-center">
                                <v-icon>{{ entry.source === 'generated' ? 'check' : 'close' }}</v-icon>
                            </td>
                            <td class="actions">
                                <v-btn small icon @click="remove(entry)" :disabled="loading || entry.source === 'generated'" class="mx-0">
                                    <v-icon>delete</v-icon>
                                </v-btn>

                                <event-schedule-entry-dialog @ok="edit" :entry="entry" :can-edit-start-at="index === 0">
                                    <v-btn small icon slot="activator" :disabled="loading || entry.source === 'generated'" class="mx-0">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </event-schedule-entry-dialog>

                                <v-menu offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-btn small icon v-on="on" :disabled="loading" class="ml-1 mr-0">
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile @click="add(entry, true)">
                                            <v-list-tile-title>Zeile davor einfügen</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click="add(entry)">
                                            <v-list-tile-title>Zeile danach einfügen</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import EventScheduleEntryDialog from '../dialogs/EventScheduleEntryDialog';
import draggable from 'vuedraggable';
import { mapMutations } from 'vuex';
import _ from 'lodash';
import gql from '../../gql';

export default {
    components: {
        EventScheduleEntryDialog,
        draggable
    },
    data() {
        return {
            id: null,
            event: null,
            currentTab: null,
            loaded: false,
            loading: false
        };
    },
    computed: {
        activeSchedule() {
            return this.event ? this.event.eventSchedules[0] : null;
        }
    },
    mounted() {
        if (this.$route.params.id) {
            this.id = +this.$route.params.id;

            this.load(this.id);
        }
    },
    methods: {
        load(id) {
            let query = gql`
            query ($eventId: Int!) {
                events (id: $eventId, ) {
                    name
                    eventSchedules {
                        id, date
                        eventScheduleEntries {
                            id, position, competition_no, title, start_at, day, time, round, duration, starter_count, duration_per_starter, source
                            ageGroup {
                                name
                            }
                            starterStyle {
                                name
                            }
                        }
                    }
                }
            }
            `;
            query({ eventId: id }).then(response => {
                // TODO only one set call
                let event = response.data.data.events[0];
                _.each(event.eventSchedules, s => {
                    s.eventScheduleEntries = _.sortBy(s.eventScheduleEntries, 'position');
                });
                this.$set(this, 'event', event);

                this.loaded = true;
            });
        },
        add(entry, before = false) {
            this.loading = true;
            let scheduleId = this.activeSchedule.id;
            let query = gql`
                mutation ($entryId: Int!, $title: String!, $duration: Int!, $type: String!) {
                    createEventScheduleEntry(entry_id: $entryId, title: $title, duration: $duration, type: $type) {
                        id, date
                        eventScheduleEntries {
                            id, position, competition_no, title, start_at, day, time, round, duration, starter_count, duration_per_starter, source
                            ageGroup {
                                name
                            }
                            starterStyle {
                                name
                            }
                        }
                    }
                }
            `;

            query({
                entryId: entry.id,
                title: "Pause",
                duration: 15,
                type: before ? 'before' : 'after'
            }).then(response => {
                let responseSchedule = response.data.data.createEventScheduleEntry;
                
                let schedule = _.find(this.event.eventSchedules, schedule => {
                    return schedule.id === scheduleId;
                });

                this.$set(schedule, 'eventScheduleEntries', _.sortBy(responseSchedule.eventScheduleEntries, 'position'));

                this.loading = false;
            });
        },
        remove(entry) {
            this.confirm({
                headline: 'Wirklich löschen?',
                text: 'Eintrag wird dauerhaft gelöscht',
                callback: () => {
                    this.loading = true;

                    let query = gql`
                        mutation ($entryId: Int!) {
                            deleteEventScheduleEntry(id: $entryId) {
                                id, date
                                eventScheduleEntries {
                                    id, position, competition_no, title, start_at, day, time, round, duration, starter_count, duration_per_starter, source
                                    ageGroup {
                                        name
                                    }
                                    starterStyle {
                                        name
                                    }
                                }
                            }
                        }
                    `;

                    query({
                        entryId: entry.id
                    }).then(response => {
                        let responseSchedule = response.data.data.deleteEventScheduleEntry;
                        let schedule = _.find(this.event.eventSchedules, schedule => schedule.id === responseSchedule.id);

                        this.$set(schedule, 'eventScheduleEntries', _.sortBy(responseSchedule.eventScheduleEntries, 'position'));

                        this.loading = false;
                    });
                }
            });
            
        },
        edit(entry) {
            this.loading = true;
            const scheduleId = this.activeSchedule.id;

            const query = gql`
                mutation ($id: Int!, $title: String!, $duration: Int!, $startAt: String!) {
                    updateEventScheduleEntry(id: $id, title: $title, duration: $duration, start_at: $startAt) {
                        id, date
                        eventScheduleEntries {
                            id, position, competition_no, title, start_at, day, time, round, duration, starter_count, duration_per_starter, source
                            ageGroup {
                                name
                            }
                            starterStyle {
                                name
                            }
                        }
                    }
                }
            `;

            const index = this.activeSchedule.eventScheduleEntries.findIndex(e => e.id === entry.id);

            query({
                id: entry.id,
                title: entry.title,
                duration: entry.duration,
                startAt: index === 0 ? entry.start_at : this.activeSchedule.eventScheduleEntries[0].start_at
            }).then(response => {
                const responseSchedule = response.data.data.updateEventScheduleEntry;
                
                const schedule = _.find(this.event.eventSchedules, schedule => {
                    return schedule.id === scheduleId;
                });

                this.$set(schedule, 'eventScheduleEntries', _.sortBy(responseSchedule.eventScheduleEntries, 'position'));

                this.loading = false;
            });
        },
        move(event) {
            // this.loading = true;
            this.$set(this, 'loading', true);

            let query = gql`
                mutation ($scheduleId: Int!, $oldPos: Int!, $newPos: Int!) {
                    moveEventScheduleEntry(scheduleId: $scheduleId, oldPos: $oldPos, newPos: $newPos) {
                        id, date
                        eventScheduleEntries {
                            id, position, competition_no, title, start_at, day, time, round, duration, starter_count, duration_per_starter, source
                            ageGroup {
                                name
                            }
                            starterStyle {
                                name
                            }
                        }
                    }
                }
            `;
 
            query({
                scheduleId: this.activeSchedule.id,
                oldPos: event.moved.oldIndex,
                newPos: event.moved.newIndex
            }).then(response => {
                let responseSchedule = response.data.data.moveEventScheduleEntry;
                let schedule = _.find(this.event.eventSchedules, schedule => schedule.id === responseSchedule.id);

                this.$set(schedule, 'eventScheduleEntries', _.sortBy(responseSchedule.eventScheduleEntries, 'position'));

                this.loading = false;
            });
        },
        download() {
            let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
            csvContent += ['NR', 'Tag', 'Uhrzeit', 'Programmpunkt', 'Altersklasse', 'Style', 'Runde', 'Starter', 'Dauer', 'Dauer pro Starter/Runde'].join(";") + "\r\n";
            this.activeSchedule.eventScheduleEntries.filter(item => item.duration > 0).forEach(item => {
                csvContent += [
                    item.competition_no,
                    item.day,
                    item.time,
                    item.title,
                    item.ageGroup ? item.ageGroup.name : '',
                    item.starterStyle ? item.starterStyle.name : '',
                    item.round,
                    item.starter_count,
                    item.duration,
                    item.duration_per_starter
                ].join(";") + "\r\n";
            });

            let encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `Zeitplan_${this.event.name}.csv`);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        ...mapMutations(['confirm'])
    }
}
</script>

<style scoped>
    .actions button {
        float: right;
    }
</style>
